import React from "react";
import VirtualTourComponent from "./virtual-tour-component";
// const TourLazy = React.lazy(()=>import('./virtual-tour-component'));
export default function VirtualTour(props) {
    return React.createElement(VirtualTourComponent, Object.assign({}, props));
    //     return <Suspense fallback={<LoadingBox style={{height:'80vh'}} />}> 
    //     <TourLazy /> 
    // </Suspense>
}
